/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
export var leaderCulomn = [{
  title: '队员',
  key: 'nickName',
  width: 100,
  fixed: 'left'
}, {
  title: '手机号',
  key: 'phone',
  width: 100
}, {
  title: '领券用户数',
  key: 'couponUserNum',
  width: 100
}, {
  title: '租车用户数',
  key: 'rentUserNum',
  width: 100
}, {
  title: '购卡用户数',
  key: 'orderUserNum',
  width: 100
}, {
  title: '退卡用户数',
  key: 'refundUserNum',
  width: 100
}, {
  title: '体验卡',
  key: 'rentOrderNum',
  width: 100
}, {
  title: '月卡',
  key: 'monthOrderNum',
  width: 100
}, {
  title: '季卡',
  key: 'seasonOrderNum',
  width: 100
}, {
  title: '半年卡',
  key: 'halfOrderNum',
  width: 100
}, {
  title: '年卡',
  key: 'yearOrderNum',
  width: 100
}, {
  title: '操作',
  key: '',
  width: 100
}];
export var memberCulomn = [{
  title: '手机号',
  key: 'phone',
  width: 100,
  fixed: 'left'
}, {
  title: '拉新日期',
  key: 'newUserDate',
  width: 100
}, {
  title: '租车日期',
  key: 'rentDate',
  width: 100
}, {
  title: '体验卡',
  key: 'rentOrderDate',
  width: 100
}, {
  title: '购买月卡',
  key: 'monthOrderDate',
  width: 100
}, {
  title: '购买季卡',
  key: 'seasonOrderDate',
  width: 100
}, {
  title: '购买半年卡',
  key: 'halfYearOrderDate',
  width: 100
}, {
  title: '购买年卡',
  key: 'yearOrderDate',
  width: 100
}];